import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.96967 11.0303C4.67678 10.7374 4.67678 10.2626 4.96967 9.96967C5.26256 9.67678 5.73744 9.67678 6.03033 9.96967L11 14.9393V2.75C11 2.33579 11.3358 2 11.75 2C12.1642 2 12.5 2.33579 12.5 2.75V14.9393L17.4697 9.96967C17.7626 9.67678 18.2374 9.67678 18.5303 9.96967C18.8232 10.2626 18.8232 10.7374 18.5303 11.0303L12.2803 17.2803C11.9874 17.5732 11.5126 17.5732 11.2197 17.2803L4.96967 11.0303Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.75 20.5C4.33579 20.5 4 20.8358 4 21.25C4 21.6642 4.33579 22 4.75 22H19.25C19.6642 22 20 21.6642 20 21.25C20 20.8358 19.6642 20.5 19.25 20.5H4.75Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgDownload;
